import { render } from "./ServicesDetailsPOS.vue?vue&type=template&id=1d82cc66"
import script from "./ServicesDetailsPOS.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsPOS.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__